export default __webpack_public_path__ + "static/media/identificacao_im.21bd3c29.svg";